import script from "./ValidationErrors.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&setup=true&lang=js"

import "./ValidationErrors.vue?vue&type=style&index=0&id=7bfedd9a&lang=css"

const __exports__ = script;

export default __exports__